import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mdn',
  standalone: true
})
export class MdnPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (digits.length === 10) {
      const area = digits.slice(0, 3);
      const prefix = digits.slice(3, 6);
      const line = digits.slice(6);
      return `(${area}) ${prefix}-${line}`;
    }
    return value;
  }
}
